module.exports = __webpack_public_path__ + "media/images/icare-partners-030826c81e9981eba46239f4e4063850.png";